import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import ErrorScreen from "../../error/ErrorScreen";
import getDataFromApi from "../../getDataFromApi";
import Loader from "../../Loader";
import YAML from 'yaml';

export default function Configuration({ expData, query, id }) {
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (!query) {
      setData(expData);
      setLoading(false);
      return;
    }
    const url = `${window['ENV'].API_URL}/models/detailed/${id}/configuration${query}`;
    getDataFromApi(url, "get")
      .then((r) => {
        if (r?.detail) alert(r.detail);
        else {
          setData(r);
          setLoading(false);
        }
      })
      .catch((e) => {
        setError(e.message);
        console.log(e);
      });
    return () => {
      setError();
    };
  }, [id, query, expData]);



  const SENSITIVE_KEYS = ["access_key", "secret_key", "session_token", "bucket_name", "Source"];

  if (loading) return <Loader />;
  if (error || !data) return <ErrorScreen message={"No Data Found"} />;

  const renderData = (item, level = 0) => {
    const aiAnnotateValue = item["Use AI to Annotate"];
    const isAiAnnotateEnabled =
      aiAnnotateValue === true || aiAnnotateValue === "Yes";
    const aiRelatedKeys = [
      "Task Name",
      "AI Assist",
      "Model Details",
      "Foundational Model Details",
      "Experiment Details",
      "Score Threshold",
      "Label Map",
    ];

    const customOrder = [
      "Dataset Name",
      "Add Data",
      "Add Labels",
      "Object Details",
      "Select Data Source",
      "Source",

      "Select Project",
      "Select Dataset",
      "Registered Devices",
      "Select Stream Id",
      "folder_name",
      "Network Path",
      "Bucket Type",

      "access_key",
      "secret_key",
      "session_token",
      "bucket_name",
      "Bucket Name",
      "Folder Path",
      "Access Key",
      "Secret Key",
      "Content",
      "Image Extensions",
      "Video Extensions",
      "Extraction Frame Rate",
      "Avoid Similar Images",
      "Similarity Threshold",
      "Use AI to Annotate",
      "Video for Inference",
      "Task Name",
      "AI Assist",
      "Experiment Details",
      "Model Details",
      "Foundational Model Details",
      "Score Threshold",
    ];


    const sortedEntries = Object.entries(item)
      .filter(([key]) => {
        if (key === "folder_name") {
          return false;
        }

        if (!isAiAnnotateEnabled) {
          return !aiRelatedKeys.includes(key);
        }

        return true;
      })
      .sort(([keyA], [keyB]) => {
        const indexA = customOrder.indexOf(keyA);
        const indexB = customOrder.indexOf(keyB);
        return (indexA !== -1 ? indexA : customOrder.length) - (indexB !== -1 ? indexB : customOrder.length);
      });

    return sortedEntries?.map(([key, value]) => {

      if (SENSITIVE_KEYS.includes(key) || ["Model Name"].includes(key) || ["Experiment Name"].includes(key) ) return null;

      if (key === "Add Labels") key = "Labels Provided as";
      if (key === "Select Data Source") key = "Data Source";

      if (typeof value === "boolean") {
        value = value ? "Yes" : "No";
      }
      if(key === "model_name") return null;
      if(key === "exp_name") return null;
      if (key === "Network Path" && expData.configuration["Select Data Source"] !== "LocalTransfer") {
        return null
      }
      if (key === "Select Project" && expData.configuration["Select Data Source"] !== "PlatformImport") {
        return null
      }
      if (key === "Select Dataset" && expData.configuration["Select Data Source"] !== "PlatformImport") {
        return null
      }
      if (key === "Registered Devices" && expData.configuration["Select Data Source"] !== "Registered_Device") {
        return null
      }
      if (key === "Select Stream Id" && expData.configuration["Select Data Source"] !== "Registered_Device") {
        return null
      }
      if (key === "Bucket Name" && expData.configuration["Select Data Source"] !== "CloudS3") {
        return null
      }
      if (key === "Bucket Type" && expData.configuration["Select Data Source"] !== "CloudS3") {
        return null
      }
      if (key === "Access Key" && expData.configuration["Select Data Source"] !== "CloudS3") {
        return null
      }
      if (key === "Secret Key" && expData.configuration["Select Data Source"] !== "CloudS3") {
        return null
      }
      if (key === "Folder Path" && expData.configuration["Select Data Source"] !== "CloudS3") {
        return null
      }

      if (!isAiAnnotateEnabled && aiRelatedKeys.includes(key)) return null;
      if (key === "Model Details" && expData.configuration["AI Assist"] !== "Use Model") return null;
      if (key === "Foundational Model Details" && expData.configuration["AI Assist"] !== "Use Foundational Model") return null;


      if (key === "Model Details" && typeof value === "object" && value["Model Name"] && expData.configuration["AI Assist"] === "Use Model") {

     

        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>
              <Col sm="6" className="pt-2 pb-2">
                {expData.configuration.model_name}
              </Col>
            </Row>

            <div >
              {renderData(value, level + 1)}
            </div>
          </div>
        );
      }

      if (key === "Select Project" && expData.configuration["Project"]) {

        console.log(expData.configuration["Project"]);

        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>
              <Col sm="6" className="pt-2 pb-2">
              {expData.configuration["Project"]}
              </Col>
            </Row>

          </div>
        );
      }

      if (key === "Select Project" && expData.configuration["Project"]) {

        console.log(expData.configuration["Project"]);

        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>
              <Col sm="6" className="pt-2 pb-2">
              {expData.configuration["Project"]}
              </Col>
            </Row>

          </div>
        );
      }

      if (key === "Project") return null;

      if (key === "Select Dataset" && expData.configuration["Dataset"]) {

        console.log(expData.configuration["Dataset"]);

        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>
              <Col sm="6" className="pt-2 pb-2">
              {expData.configuration["Dataset"]}
              </Col>
            </Row>

          </div>
        );
      }

      if(key === "Experiment Details" && expData.configuration["AI Assist"] !== "Use Platform Experiment") return null;


     
      if(key === "Experiment Details" && typeof value === "object" && value["Experiment Name"] && expData.configuration["AI Assist"] === "Use Platform Experiment") {
      return (
        <div key={key}>
          <Row className="grey-card4">
            <Col sm="6" className="pt-2 pb-2">
              <strong>{key}</strong>
            </Col>
            <Col sm="6" className="pt-2 pb-2">
              {expData.configuration.exp_name}
            </Col>
          </Row>

          <div >
            {renderData(value, level + 1)}
          </div>
        </div>
      );
    }

      if (
        key === "Foundational Model Details" &&
        typeof value === "object" &&
        expData.configuration["AI Assist"] === "Use Foundational Model"
      ) {
        const modelDisplayValue =
          expData.configuration.model_name ||
          value["Model Name"] ||
          "-";

        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>Foundational Models</strong>
              </Col>
              <Col sm="6" className="pt-2 pb-2">
                {String(modelDisplayValue)}
              </Col>
            </Row>

            {value["LABELS_PROMPT_KEY"] && (
              <Row className="grey-card4">
                <Col sm="6" className="pt-2 pb-2">
                  <strong>Prompt Labels</strong>
                </Col>
                <Col sm="6" className="pt-2 pb-2">
                  {String(value["LABELS_PROMPT_KEY"])}
                </Col>
              </Row>
            )}
          </div>
        );
      }

      if (key === 'Dataset') return null;

      if (key === "Image Extensions" && expData.configuration["Content"] !== "ImagesOnly") return null;
      if(key === "Extraction Frame Rate" && expData.configuration["Content"] !== "VideosOnly") return null;
      if(key === "Directory Format" && expData.configuration["Content"] !== "Dataset") return null;
      
      if(key === "Import/Load Labels" && expData.configuration["Content"] !== "Dataset") return null;
      if (key === "Map to New Labels" && expData.configuration["Content"] !== "Dataset") return null;

      if (key === "Image Extensions" && expData.configuration["Content"] !== "ImagesOnly") return null;
      if (key === "Image Extensions" && value.length > 0 && expData.configuration["Content"] === "ImagesOnly") {

        return (
          <div key={key}>
            <Row>
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>

              <Col sm="6" className="pt-2 pb-2">
                {value.join(", ")}
              </Col>



            </Row>

          </div>
        )
      }

      if (key === "Video Extensions" && expData.configuration["Content"] !== "VideosOnly") return null;

      if (key === "Video Extensions" && value.length > 0 && expData.configuration["Content"] === "VideosOnly") {

        return (
          <div key={key}>
            <Row>
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>

              <Col sm="6" className="pt-2 pb-2">
                {value.join(", ")}
              </Col>



            </Row>

          </div>
        )
      }

      if (key === "Access Key" || key === "Secret Key") {
        const maskedValue = `${"*".repeat(value.length - 4)}${value.slice(-4)}`;
        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>
              <Col sm="6" className="pt-2 pb-2">
                {maskedValue}
              </Col>
            </Row>
          </div>
        );
      }

      if (key === "Similarity Threshold" && item["Avoid Similar Images"] !== true) {
        return null;
      }

      if (key === "Label Map" && Array.isArray(value)) {

        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>
              <Col sm="6">
                <div style={{ paddingBottom: "10px" }}>
                  <Row>
                    <Col sm="6" className="pt-2 pb-2"><strong>Model Labels</strong></Col>
                    <Col sm="6" className="pt-2 pb-2"><strong>Dataset Label</strong></Col>
                  </Row>
                  {value?.map((entry, idx) => (
                    <Row key={idx}>
                      <Col sm="6" className="pt-2 pb-2">
                        {Array.isArray(entry["Model Labels"]) ? entry["Model Labels"].join(", ") : entry["Model Labels"]}
                      </Col>
                      <Col sm="6" className="pt-2 pb-2">{entry["Dataset Label"]}</Col>
                    </Row>
                  ))}
                </div>
              </Col>
            </Row>

          </div>
        );
      }

      if (key === "Object Details" && typeof value === "object") {
        const labelsArray = value.labels?.split(",").filter(label => label.trim() !== ""); // Split and remove empty entries

        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>Labels</strong>
              </Col>
              <Col sm="6">
                <div style={{ paddingBottom: "10px" }}>
                  <Row>
                    {labelsArray?.map((label, index) => (
                      <Col sm="3" key={index} className="pt-2 pb-2">
                        {label}
                      </Col>
                    ))}
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        );
      }
      if (key === "detailed_labels" && Array.isArray(value)) {

        return (
          <div key={key}>
            <Row>
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>
              <Col sm="6">
                <div style={{ paddingBottom: "10px" }}>
                  <Row>
                    <Col sm="6" className="pt-2 pb-2"><strong>name</strong></Col>
                    <Col sm="6" className="pt-2 pb-2"><strong>description</strong></Col>
                  </Row>
                  {value?.map((label, idx) => (
                    <Row key={idx}>
                      <Col sm="6" className="pt-2 pb-2">{label.name}</Col>
                      <Col sm="6" className="pt-2 pb-2">{label.description}</Col>
                    </Row>
                  ))}
                </div>
              </Col>
            </Row>
          </div>
        );
      }

      if (key === "Map to New Labels" && Array.isArray(value)) {
        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>
              <Col sm="6" className="pt-2 pb-2">
                <table>
                  <thead>
                    <tr>
                      <th>Source Label</th>&nbsp;&nbsp;&nbsp;&nbsp;
                      <th>Target Label</th>
                    </tr>
                  </thead>
                  <tbody>
                    {value?.map((labelMap, idx) => (
                      <tr key={idx}>
                        <td>
                          {labelMap["Source Label"].join(", ")}
                        </td>&nbsp;
                        <td>{labelMap["Target Label"]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>
        );
      } else {

        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>
              <Col sm="6" className="pt-2 pb-2">
                {typeof value === "object" ? JSON.stringify(value) : String(value)}
              </Col>
            </Row>
          </div>
        );
      }


      if (Array.isArray(value) && value.length > 0) {
        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>
              <Col sm="6" className="pt-2 pb-2">
                {value.map((val, idx) => (
                  <div key={`${key}-${idx}`} >
                    {typeof val === "object" ? renderData(val, level + 1) : String(val)}
                  </div>
                ))}
              </Col>
            </Row>
          </div>
        );
      } else if (typeof value === "object" && Object.keys(value).length > 0) {
        return (
          <div key={key}>
            <Row className="grey-card4">
              <Col sm="6" className="pt-2 pb-2">
                <strong>{key}</strong>
              </Col>
              <Col sm="6" className="pt-2 pb-2">
                {renderData(value, level + 1)}
              </Col>
            </Row>
          </div>
        );
      } else {
        return (
          <Row className="grey-card4" key={key}>
            <Col sm="6" className="pt-2 pb-2">
              <strong>{key}</strong>
            </Col>
            <Col sm="6" className="pt-2 pb-2">
              {typeof value === "boolean" ? (value ? "True" : "False") : value}
            </Col>
          </Row>
        );
      }
    });
  }


  return (
    <div className="my-4">
      <h5>Review</h5>
      <hr />
      {data && data.configuration ? renderData(data.configuration) : <p>No configuration data available.</p>}
    </div>
  );
}
